<template>
    <div class="app-navbar" v-if="lang">
        <div class="icon">
            <span @click="toggle"><md-icon class="toggle">dehaze</md-icon></span>
            <router-link :to="{ name: link }" v-if="$route.meta.return" class="return"><md-icon>keyboard_backspace</md-icon></router-link>
            <span class="md-title route">{{ $route.meta.name }}</span>
        </div>
        <div class="navbar-right">
            <div>
                <a v-if="!user.plan_end" class="button hidden-xs hidden-sm_j" :href="payLink" target="_blank">Pago en Linea</a>
            </div>
            <div class="u-relative hidden-xs" @click="activeButton('notification')" v-if="user.type == 'healt_provider'">
                <md-icon class="icon_notificatoins"
                    :class="{ 'active': show.notification }">
                    people_outline
                </md-icon>
                <!--<md-icon class="md-primary u-notification" v-if="notifications.length > 0">lens</md-icon>-->
            </div>
            <div class="u-relative hidden" @click="activeButton('people')">
                <md-icon class="icon_people"
                    :class="{ 'active': show.people }">
                    notifications_none
                </md-icon>
                <md-icon class="md-primary u-notification">lens</md-icon>
            </div>
            <div class="dropdown" @click="activeButton('profile')">
                <md-avatar class="icon_avatar"
                    :class="{ 'active': show.profile }">
                    <img :src="user.avatar" alt="Avatar">
                </md-avatar>
                <span class="icon_caret">
                    <i aria-hidden="true" class="md-icon md-list-expand-indicator md-theme-default material-icons">keyboard_arrow_down</i>
                </span>
            </div>
        </div>
        <div v-show="show.notification" id="app_notifications">
            <md-list class="custom-list md-triple-line u-block-notification" v-if="notifications.length > 0">
                <md-list-item
                    v-for="(notification,index) in notifications" :key="notification.id"
                    >
                    <md-avatar>
                        <img :src="imgNotification(notification.office.path)" alt="People">
                    </md-avatar>
                    <div class="md-list-text-container">
                        <span>{{ notification.user.name }}</span>
                        <span v-html="formatNotification(notification.message)"></span>
                        <p>{{ notification.office.name }} - {{ difference(notification.created_at) }}.</p>
                    </div>
                    <md-button class="md-icon-button md-list-action hidden">
                        <md-icon class="md-primary u-font-75 u-color-red">lens</md-icon>
                    </md-button>
                    <md-divider class="md-inset"></md-divider>
                </md-list-item>
                <!-- no tenemos la page apra verlas todas, la flecha sobra -->
                <div class="divider hidden" style="height: 2em; text-align: center; padding:.25em 0;cursor:pointer">
                    <md-icon>keyboard_arrow_down</md-icon>
                </div>
            </md-list>
            <md-list v-else class="custom-list md-triple-line u-block-notification">
                <md-list-item>
                    <div class="md-list-text-container">
                        <span>{{ translate.pages.partials.navbar.noNotifications }}</span>
                    </div>
                </md-list-item>
            </md-list>
        </div>
        <div v-if="show.people">
            <md-list class="custom-list md-triple-line u-block-people">
                <md-list-item>
                    <md-avatar>
                        <img src="https://placeimg.com/40/40/people/3" alt="People">
                    </md-avatar>
                    <div class="md-list-text-container">
                        <span><small>{{ translate.pages.partials.navbar.subordinate }}: Marco Robledo</small></span>
                        <span>ha <strong>editado</strong> una consulta</span>
                        <p>hace 30min.</p>
                    </div>
                    <md-button class="md-icon-button md-list-action">
                        <md-icon class="md-primary u-font-75">lens</md-icon>
                    </md-button>
                    <md-divider class="md-inset"></md-divider>
                </md-list-item>
                <md-list-item>
                    <md-avatar>
                        <img src="https://placeimg.com/40/40/people/4" alt="People">
                    </md-avatar>
                    <div class="md-list-text-container">
                        <span><small>{{ translate.pages.partials.navbar.subordinate }}: Marco Robledo</small></span>
                        <span>ha <strong>agregado</strong> una consulta</span>
                        <p>+ hace 2h.</p>
                    </div>
                    <md-button class="md-icon-button md-list-action">
                        <md-icon class="u-font-75">lens</md-icon>
                    </md-button>
                    <md-divider class="md-inset"></md-divider>
                </md-list-item>
                <div class="divider" style="height: 2em; text-align: center; padding:.25em 0;cursor:pointer">
                    <md-icon>keyboard_arrow_down</md-icon>
                </div>
            </md-list>
        </div>
        <div v-if="show.profile" id="app_profile">
            <md-list class="u-block-profile navbar-dropdown">
                <md-list-item>
                    <md-layout md-flex="80">
                        <span class="u-font-85 full-width user-name">{{ user.full_name }}</span>
                        <br>
                        <span class="u-font-85 full-width">{{ user.email }}</span>
                    </md-layout>
                    <md-layout md-flex="20">
                        <md-button class="md-icon-button md-list-action" @click.native="redirect">
                            <md-icon class="md-primary">edit</md-icon>
                        </md-button>
                    </md-layout>
                </md-list-item>
                <div class="item-divider"></div>
                <md-list-item class="hidden">
                    <router-link exact :to="{ name: 'Plans' }">
                        <span class="u-font-85">{{ translate.pages.partials.navbar.updatePlan }}</span>
                        <span class="plan_current">{{ translate.pages.partials.navbar.planType.basic }}</span>
                    </router-link>
                </md-list-item>
                <!--<div class="item-divider"></div>-->
                <md-list-item class="hidden">
                    <router-link exact to="/"><span class="u-font-85">{{ translate.pages.partials.navbar.exclusivePage }}</span></router-link>
                </md-list-item>
                <!--<div class="item-divider"></div>-->
                <md-list-item v-if="user.type == 'healt_provider'"  @click.native="hideProfile">
                    <router-link exact :to="{ name: 'Office' }"><span class="u-font-85">{{ translate.pages.partials.navbar.myConsulations }}</span></router-link>
                </md-list-item>
                <div class="item-divider"></div>
                <md-list-item @click.native="hideProfile">
                    <router-link exact :to="{ name: 'logout' }"><span class="u-font-85" >{{ translate.pages.partials.navbar.closeSession }}</span></router-link>
                </md-list-item>
            </md-list>
        </div>
    </div>
</template>
<script>
    import moment from 'moment';
    export default {
        data() {
            return {
                notifications: []
            }
        },
        computed: {
            // Get show navbar
            show() {
                return this.$store.getters.navbar.show;
            },
            // Get link
            link() {
                return this.$route.meta.return;
            },
            // Get User
            user() {
                return this.$store.getters.user;
            },
            // Get Language
            translate(){
                return this.$store.getters.language.app[this.lang].prestador;
            },
            // Get lang
            lang(){
                return this.$store.getters.language.lang;
            },
            payLink(){
                var link;
                try{
                    if(top.location.href){
                        link = 'https://tienda.agendaenlinea.cl/'
                    }
                }catch (e){
                    link = 'http://redsaludcajagm.cl/planes/'
                }
                return link
            }
        },
        methods: {
            // Format Notification
            formatNotification(value){
                let arr = value.split("|");
                console.log(this.translate)
                console.log(arr)
                let msg = "<strong>" + this.translate.notifications[arr[0]] +"</strong> "
                msg += this.translate.notifications.type[arr[1]] + ", "
                msg += this.translate.notifications[arr[2]] + "."
                //msg += this.translate.notifications[arr[3]] + "."
                return msg;
            },
            // Active button
            activeButton(scope){
                Object.keys(this.show).map((k,i) => {
                    if (k == scope) {
                        if(! this.show[k] )
                        {
                            if(k == 'notification'){
                                this.$http.get('/notification',{
                                    headers: {
                                        Authorization : 'Bearer '+ this.$auth.getToken(),
                                    }
                                }).then(response => {
                                    let name_event = 'show' + this.capitalizeFirstLetter(scope);
                                    this.notifications = response.data.data;
                                    this.$store.dispatch(name_event);
                                });
                            }else{
                                let name_event = 'show' + this.capitalizeFirstLetter(scope);
                                setTimeout(() => {
                                    this.$store.dispatch(name_event);
                                }, 100);
                            }
                        }else{
                            let name_event = 'hide' + this.capitalizeFirstLetter(scope);
                            this.$store.dispatch(name_event);
                        }
                    } else {
                        let name_event = 'hide' + this.capitalizeFirstLetter(k);
                        this.$store.dispatch(name_event);
                    }
                });
            },
            // Toggle sidebar
            toggle() {
                this.$emit('toggleSidebar')
            },
            // Hide Profile
            hideProfile() {
                this.show.profile = false;
            },
            // Redirect profile
            redirect() {
                this.$router.push({name:'profile'});
                this.show.profile = false;
            },
            // Get difference
            difference(timestamp){
                return moment(timestamp).locale("es").fromNow();
            },
            // Format string
            capitalizeFirstLetter(string) {
                return string.charAt(0).toUpperCase() + string.slice(1);
            },
            // Get path
            imgNotification(path){
                if(path){
                    return path;
                }
                return 'https://api.agendaenlinea.cl/image/default_avatar.png';
            }
        }
    }
</script>
<style lang="stylus" scoped>
    @import '../../../assets/styles/variables/color.styl'
    @media (max-width: 400px)
        .hidden-xs
            display none !important
    .hidden
        display none!important
    .u-relative
        position relative
    .u-notification
        color color_error !important
        font-size .75em
        position absolute
        top 2em
        left 2.25em
    .u-block-notification, .u-block-people, .u-block-profile
        border 1px solid #eee
        box-shadow 0 1px 1px 1px #ccc
        padding 0
        position absolute
        right 0
        top 80px
        width 400px
        z-index 100
    .u-block-people
        right 3em
    .u-block-profile
        right 0.5em
        width 275px
    .u-font-85
        font-size .85em
    .u-font-75
        font-size .75em
    .u-color-red
        color color_error !important
    .plan_current
        background color_form_placeholder
        border-radius 1em
        color white
        font-size .75em
        margin-left 1em
        height 2.5em
        padding-left .5em
        padding-right .5em
    .item-divider
        height 1px
        width 100%
        background color_form_border
    .app-navbar
        height 80px
        background-color color_header
        box-shadow  0 1px 0 rgba(0,0,0,0.05), 0 2px 5px rgba(0,0,0,0.05)
    .icon
        float left
        line-height 80px
        padding-left 2em
        color color_sidebar
        .md-icon
            color #959ea6
            &:hover
                color color_sidebar
        .toggle
            font-size 2.25em
            cursor pointer
            width 35px
        .route
            padding-left .5em
            padding-top 1em
            font-size 1.1em
            color #959ea6
        .return
            color black
            &:hover
                color black
                text-decoration none
                opacity 0.5
    .navbar-right
        float right
        display flex
        line-height 80px
        .button
            border 1px solid color_main
            border-radius 1em
            padding .5em 1.5em
            background color_background
            color color_main
            font-weight bold
            cursor pointer
            &:hover
                background color_main
                color white
                box-shadow 10px 10px 5px color_value
                text-decoration none
            @media (max-width: 767px)
                .hidden-xs
                    display none !important
        .icon_notificatoins, .icon_people
            border-radius 50%
            cursor pointer
            height 1.45em
            margin-left 0.25em
            padding-left 5px
            width 1.45em
            transition all 0.5s ease-out
            &:hover
                background color_form_border
            &.active
                background color_form_border
        .dropdown
            cursor pointer
            float right
            margin-left .75em
            .icon_caret
                margin-left -0.5em
                i
                    font-size 1.25em
                    color color_sidebar
    .full-width
        width 100%

@media (max-width: 500px)
	.hidden-sm_j
		display none !important
</style>



// WEBPACK FOOTER //
// Navbar.vue?4dace698